import { Center, Divider, Group, Stack } from '@mantine/core';
import { formatScore } from '@repo/common/utils/dataQuality';
import { Text } from '@repo/foundations';
import dayjs from 'dayjs';
import { ChartTooltip } from '../../Chart/components/ChartTooltip';
import { DataQualityProgressIcon } from '../DataQualityProgressIcon';
import { QualityScoreRing } from '../QualityScoreRing';

export interface PolicyTimeseriesTooltipPolicyV2 {
	id: string;
	name: string;
	percentage: number;
}

export interface PolicyTimeseriesTooltipV2Props {
	x: number;
	y: number;
	date: string;
	overallPercentage?: number;
	policies: PolicyTimeseriesTooltipPolicyV2[];
}

export function PolicyTimeseriesTooltipV2({
	x,
	y,
	date,
	overallPercentage,
	policies,
}: PolicyTimeseriesTooltipV2Props) {
	return (
		<ChartTooltip x={x} y={y}>
			<Stack spacing={0} maw={260}>
				<Text size="sm" color="text/secondary/default" px="sm" pt="sm">
					{dayjs.utc(date).format('MMM D, YYYY')}
				</Text>
				<Stack spacing="sm" p="md">
					<Center>
						<QualityScoreRing
							score={overallPercentage ?? 0}
							size="md"
							displayBadge={overallPercentage !== undefined}
							showInnerContent={overallPercentage !== undefined}
						/>
					</Center>
					<Divider color="border/secondary/default" />
					<Stack spacing="xs">
						{policies.length === 0 ? (
							<Text size="sm" color="text/secondary/default">
								No policies configured
							</Text>
						) : (
							policies.map((policy) => (
								<Group key={policy.id} position="apart" spacing={0}>
									<Group spacing="xs">
										<DataQualityProgressIcon score={policy.percentage} />
										<Text size="sm" fw={500}>
											{policy.name}
										</Text>
									</Group>
									<Text size="sm" color="text/secondary/default">
										{`${formatScore(policy.percentage)}%`}
									</Text>
								</Group>
							))
						)}
					</Stack>
				</Stack>
			</Stack>
		</ChartTooltip>
	);
}
